import React from "react";
import { motion } from "framer-motion";

export const Card = ({ className = "", children, ...rest }) => (
  <div className={`bg-card border border-border rounded-2xl ${className}`} {...rest}>
    {children}
  </div>
);

const COLORS = {
  primary: { text: "text-primary", bg: "bg-primary/10" },
  sky: { text: "text-sky-400", bg: "bg-sky-400/10" },
  amber: { text: "text-amber-400", bg: "bg-amber-400/10" },
  emerald: { text: "text-emerald-400", bg: "bg-emerald-400/10" },
  rose: { text: "text-rose-400", bg: "bg-rose-400/10" },
};

const fitClass = (v) => {
  const n = String(v ?? "").length;
  if (n > 16) return "text-base sm:text-lg";
  if (n > 12) return "text-lg sm:text-xl";
  if (n > 9) return "text-xl sm:text-2xl";
  return "text-2xl sm:text-3xl";
};

export const Kpi = ({ label, value, sub, icon: Icon, color = "primary", index = 0, testId }) => {
  const c = COLORS[color] || COLORS.primary;
  return (
    <motion.div
      data-testid={testId}
      initial={{ opacity: 0, y: 14 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4, delay: index * 0.06, ease: [0.16, 1, 0.3, 1] }}
      className="bg-card border border-border rounded-2xl p-5 hover:border-border/80 transition-colors min-w-0 overflow-hidden"
    >
      <div className="flex items-start justify-between">
        <span className="text-xs font-semibold uppercase tracking-wider text-muted-foreground">{label}</span>
        <div className={`h-9 w-9 rounded-lg flex items-center justify-center ${c.bg} ${c.text}`}>
          <Icon className="h-4.5 w-4.5" style={{ width: 18, height: 18 }} />
        </div>
      </div>
      <div className={`mt-4 font-mono font-bold tracking-tight tabular-nums break-all leading-tight ${fitClass(value)}`} title={typeof value === "string" ? value : undefined}>{value}</div>
      {sub && <div className={`mt-2 text-xs font-medium ${c.text}`}>{sub}</div>}
    </motion.div>
  );
};
